import React from "react";
import ManageBookings from "./ManageBookings";

const ManageDeletedBookings = () => {
    return (<ManageBookings bookingStatus='DELETED' title='Deleted Bookings'/>)
}

export default ManageDeletedBookings;
